import React from 'react';

import { Utilities } from '../../../weborder/Utilities';

type Props = {
  messages: string[];
};

export function Toastie(props: Props): JSX.Element | null {
  const { messages } = props;

  if (!messages || messages.length === 0) {
    return null;
  }

  const content = messages.map((message, index) => (
    <span aria-live="polite" key={index}>
      {message}
    </span>
  ));

  const offset: string = Utilities.extraOption('data-offset') || '0';

  return (
    <div className="fd-toast" aria-live="polite" style={{ top: offset }}>
      <div>{content}</div>
    </div>
  );
}
